export { default as Banner } from './Banner';



// WEBPACK FOOTER //
// ./src/pages/Kategorija/components/index.js